import React, { useState } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import MainAccountContent from './MainAccountContent';
import SubAccountContent from './SubAccountContent';

import { ReactComponent as MainAccountSvg } from '../../image/MainAccount.svg';
import { ReactComponent as SubAccountSvg } from '../../image/SubAccount.svg';

export default function MyAccountBox(props) {
  const {
    id,
    email,
    owenrName,
    setOwnerName,
    ownerProfile,
    phone,
    phoneCountryCode,
    setPhone,
    setPhoneCountryCode,
    passwordModifiedAt,
    secondPasswordModifiedAt,
    refetchAccount,
    linkopayProps
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [activeTab, setActiveTab] = useState('main');

  function onClickMainTab() {
    setActiveTab('main');
  }

  function onClickSubTab() {
    setActiveTab('sub');
  }

  // 탭 토글 (메인 계정 / 부계정) //
  function renderTabToggle() {
    return (
      <TabToggleWrapper>
        <TabButton
          isActive={activeTab === 'main'}
          activeBackground={theme.background}
          activeBorder={theme.background}
          onClick={onClickMainTab}>
          <TabIconWrapper>
            <MainAccountIcon $isActive={activeTab === 'main'} />
          </TabIconWrapper>
          <TabText
            color={activeTab === 'main' ? theme.text : theme.subText}>
            {t('myStoreSetting.account.tab.main')}
          </TabText>
        </TabButton>
        <TabButton
          isActive={activeTab === 'sub'}
          activeBackground={theme.background}
          activeBorder={theme.background}
          onClick={onClickSubTab}>
          <TabIconWrapper>
            <SubAccountIcon $isActive={activeTab === 'sub'} />
          </TabIconWrapper>
          <TabText
            color={activeTab === 'sub' ? theme.text : theme.subText}>
            {t('myStoreSetting.account.tab.sub')}
          </TabText>
        </TabButton>
      </TabToggleWrapper>
    );
  }

  return (
    <TopLevelWrapper>
      <SectionTitleRow>
        <SectionTitleHighlight>{t('myStoreSetting.account.sectionLabel')}</SectionTitleHighlight>
        <SectionTitleText>{t('myStoreSetting.account.sectionTitle')}</SectionTitleText>
      </SectionTitleRow>
      {renderTabToggle()}
      {
        activeTab === 'main' &&
        <MainAccountContent
          id={id}
          email={email}
          ownerName={owenrName}
          setOwnerName={setOwnerName}
          ownerProfile={ownerProfile}
          phone={phone}
          phoneCountryCode={phoneCountryCode}
          setPhone={setPhone}
          setPhoneCountryCode={setPhoneCountryCode}
          passwordModifiedAt={passwordModifiedAt}
          secondPasswordModifiedAt={secondPasswordModifiedAt}
          refetchAccount={refetchAccount}
          linkopayProps={linkopayProps} />
      }
      {
        activeTab === 'sub' &&
        <SubAccountContent />
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: stretch;

  gap: 15px;

  width: 100%;

  margin-top: 36px;
`;

const SectionTitleRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;

  height: 30px;
`;

const SectionTitleHighlight = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
  white-space: nowrap;
`;

const SectionTitleText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
  white-space: nowrap;
`;

const TabToggleWrapper = styled.div`
  display: flex;
  align-items: center;

  gap: 10px;

  padding: 5px;
  box-sizing: border-box;

  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  width: fit-content;
`;

const TabButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;

  padding: 5px 10px;
  box-sizing: border-box;

  height: 31px;

  border-radius: 8px;
  border: 1px solid ${props => props.isActive ? props.activeBorder : 'transparent'};
  background-color: ${props => props.isActive ? props.activeBackground : 'transparent'};

  transition: all 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TabIconWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;
`;

const MainAccountIcon = styled(MainAccountSvg)`
  width: 20px;
  height: 20px;

  & path {
    stroke: ${props => props.$isActive ? props.theme.text : props.theme.subText};
  }
`;

const SubAccountIcon = styled(SubAccountSvg)`
  width: 20px;
  height: 20px;

  & path {
    stroke: ${props => props.$isActive ? props.theme.text : props.theme.subText};
  }
`;

const TabText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  white-space: nowrap;
`;
